<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>待遇查询</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="schedule">
            <h2 class="tit8"><span><img src="../../../static/images/guide_sign11.png"> 待遇查询</span></h2>
            <div class="schedule_sea2">
            <!--  <el-input
                placeholder="请输身份证号"
                v-model="person_uid" style="width: 450px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>-->
              <template>
                <el-select style="width: 450px" v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in relationList"
                    :key="item.value"
                    :label="item.name+'（'+item.user_idcard+'）'"
                    :value="item.user_idcard_no_occlude">
                  </el-option>
                </el-select>
              </template>
              <el-button type="primary"   @click="getPersonInformation"  icon="el-icon-search">搜索</el-button>
              <span style="color: #f56c6c;font-size: 12px;padding-left: 15px">提示：如未绑定人员请在青民通办APP绑定！</span>
            </div>
            <div class="clear"></div>
            <div style="padding-top: 30px"  v-if="personInformation && personInformation.person_name!=null ">
              <table style="white-space:nowrap">
                <tr >
                  <td colspan="2" style="padding-left: 120px;"><h4 class="el-icon-zoom-in">&nbsp; 基本信息</h4></td>
                </tr>
              </table>
              <el-row>
                <el-col :span="1"><div class="grid-content bg-purple">&nbsp;</div></el-col>
                <el-col :span="20"><div class="grid-content bg-purple">
                  <table width="90%" border="0" cellspacing="1" cellpadding="0" class="details_tab" >
                    <tr>
                      <td width="10%" class="grey">姓 名</td>
                      <td width="20%">{{personInformation.person_name}}</td>
                      <td width="10%" class="grey">出生日期</td>
                      <td width="20%">{{personInformation.person_birthday}}</td>
                    </tr>

                    <tr>
                      <td width="10%" class="grey">性 别</td>
                      <td width="20%" v-if="personInformation.person_sex==1">男</td>
                      <td width="20%" v-else>女</td>
                      <td width="10%" class="grey">身份证</td>
                      <td width="20%">{{personInformation.person_uid_ellipsis}}</td>
                    </tr>
                    <tr>
                      <td width="10%" class="grey">年 龄</td>
                      <td width="20%">{{personInformation.person_age}}</td>
                      <td width="10%" class="grey">民 族</td>
                      <td width="20%">{{personInformation.nation_type_name}}</td>
                    </tr>
                    <tr>
                      <td width="10%" class="grey">户籍地址</td>
                      <td width="37%" colspan="3">{{personInformation.reg_addr}}</td>
                    </tr>
                    <tr>
                      <td width="10%" class="grey">居住地址</td>
                      <td width="37%" colspan="3">{{personInformation.living_address}}</td>
                    </tr>

                  </table>

                  <table style="white-space:nowrap">
                    <tr v-if="personInformation.dis_nim!=null">
                      <td colspan="2" style="padding-left: 120px;padding-top: 30px"><h4 class="el-icon-zoom-in">&nbsp; 残疾证信息</h4></td>
                    </tr>
                  </table>
                </div></el-col>
                <el-col :span="3"><div class="grid-content bg-purple-light">
                  <div style="padding-top: 142px;margin-left: -30px">
                    <img v-if="personInformation.photo_id!=''&& personInformation.photo_id!='-1'&& personInformation.photo_id!=undefined" style="height: 130px;width: 100px;margin-top: -500px" :src="getImg(personInformation.photo_id)"/>
                    <img v-else style="height: 150px;width: 100px;margin-top: -500px" src="../../../static/images/mrtx.jpg"/>
                  </div>

                </div></el-col>
              </el-row>

            <table v-if="personInformation.dis_nim!=null" width="80%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
              <tr>
                <td width="13%" class="grey">残疾证号</td>
                <td width="37%">{{personInformation.dis_num}}</td>
                <td width="12%" class="grey">残疾类型</td>
                <td width="38%">{{health_type}}</td>
              </tr>
             <!-- <tr>
                <td width="13%" class="grey">残疾等级</td>
                <td width="37%" colspan="3">{{personInformation.dis_level}}</td>
              </tr>-->

            </table>
              <table style="white-space:nowrap">
                <tr >
                  <td colspan="2" style="padding-left: 120px;padding-top: 30px"><h4 class="el-icon-zoom-in">&nbsp; 待遇详情</h4></td>
                </tr>
              </table>
              <div v-if="enjoyList!=null && enjoyList.length>0">

                <el-row>
                  <el-col :span="2"><div class="grid-content bg-purple">&nbsp;</div></el-col>
                  <el-col :span="22"><div class="grid-content bg-purple-light">
                    <div class="publicity" style="width: 90%;text-align: center">
                      <table  width="100%" border="0" cellspacing="1" cellpadding="0" >
                        <tr class="first">
                          <td  width="150px">待遇类别</td>
                          <td width="80px">状态</td>
                          <td width="80">在享情况</td>
                          <td width="150px">银行类型</td>
                          <td width="180px">银行卡号</td>
                          <td width="70">操作</td>
                        </tr>
                        <tr  v-for="(item,index) in enjoyList" :key="index">
                          <td align="center" style="width: 200px" nowrap="true">&nbsp;{{item.archiveTypeName}}</td>
                          <td align="center" style="color: #67C23A " nowrap="true" v-if="item.state=='正常'">&nbsp; {{item.state}}</td>
                          <td align="center" style="color: #E6A23C " nowrap="true" v-if="item.state=='挂起'">&nbsp; {{item.state}}</td>
                          <td align="center" style="color: #F56C6C " nowrap="true" v-if="item.state=='停发'">&nbsp; {{item.state}}</td>

                          <td align="center" nowrap="true">{{item.sharingSituation}}</td>
                          <td align="center" nowrap="true">{{item.bankName}}</td>
                          <td align="center" nowrap="true">{{item.bankCode}}</td>
                          <td align="center" nowrap="true">
                            <a href="javascript:void(0)" @click="detailSelect(item.archiveTypeCode,item.archiveId,item)"
                               style="color: #2162f0;">详情</a></td>
                        </tr>
                      </table >
                    </div>

                  </div></el-col>
                </el-row>
              </div>
              <div v-else>
                <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);padding-bottom: 50px">
                  <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                  <div>暂无待遇数据</div>
                </div>
              </div>

            </div>

            <div class="notice_con" v-else>
              <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;"/></div>
                <div style="padding-bottom: 100px">{{message}}</div>
              </div>
            </div>
          <!--  <div v-if="!this.$util.isEmpty(data.personUid)">
              <h3 class="details_tit2" style="margin-top: 20px">
                <span style="margin-right: 24px">姓名：{{data.personName}}</span>
                <span style="margin-right: 24px">性别：{{data.personSexName}}</span>
                <span style="margin-right: 24px">身份证号：{{data.personUid}}</span>
              </h3>
              <div v-for="(archive,index) in data.archiveTyeData" :key="index" style="text-align: center">
                <p style="font-size:14px; color:#848484; text-align:center; padding-top:24px;">
                  <span style="margin-right: 24px"> 待遇名称：{{archive.archiveTypeName}}</span>
                  <span> 状态：{{archive.archiveStatusName}}</span>
                </p>
                <table width="75%" border="0" cellspacing="1" cellpadding="0" class="enjoy_tab" style="margin-left:auto;margin-right:auto;margin-top:10px;float: none">
                  <tr class="enjoy_tit">
                    <td width="25%">资金科目</td>
                    <td width="25%">标准金额（元）</td>
                    <td width="25%">发放周期</td>
                  </tr>
                  <tr v-for="(classItem,index) in archive.classData" :key="index">
                    <td>{{classItem.className}}</td>
                    <td>{{classItem.standardAmount}}</td>
                    <td>{{classItem.frequency}}</td>
                  </tr>
                </table>
              </div>
            </div>-->
            <el-dialog  :visible.sync="detailShow" width="900px" >
              <template >
                <el-tabs v-model="activeName3" type="border-card">
                  <el-tab-pane  label="申报概要"  name="first">
                    <td colspan="2"><h2 class="information_tit">基本信息</h2></td>
                    <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                      <tr>
                        <td width="12%" class="grey">姓名</td>
                        <td width="38%"> {{personInformation.person_name}} </td>
                        <td width="12%" class="grey">性别</td>
                        <td width="38%"> {{personInformation.person_sex==1?"男":"女"}} </td>
                      </tr>
                      <tr>
                        <td width="12%" class="grey">年龄</td>
                        <td width="38%"> {{personInformation.person_age}} </td>
                        <td width="12%" class="grey">民族</td>
                        <td width="38%"> {{personInformation.nation_type_name}} </td>
                      </tr>
                      <tr>
                        <td width="12%" class="grey">身份证号</td>
                        <td width="38%"> {{personInformation.person_uid_ellipsis}} </td>
                        <td width="12%" class="grey">户籍地址</td>
                        <td width="38%"> {{personInformation.reg_addr}} </td>
                      </tr>
                      <tr>
                        <td width="12%" class="grey">居住地址</td>
                        <td width="38%"> {{personInformation.living_address}} </td>
                        <td width="12%" class="grey">联系电话</td>
                        <td width="38%"> {{personInformation.mobile}} </td>
                      </tr>
                    </table>
                    <td colspan="2"><h2 class="information_tit">对象信息</h2></td>
                    <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                      <tr>
                        <td width="12%" class="grey">申请日期</td>
                        <td width="38%"> {{tempPeople.applyDate}} </td>
                        <td width="12%" class="grey">对象类别</td>
                        <td width="38%"> {{tempPeople.className}} </td>
                      </tr>
                      <tr>
                        <td width="12%" class="grey">应发月</td>
                        <td width="38%"> {{tempPeople.shdPeriodId}} </td>
                        <td width="12%" class="grey">始发月</td>
                        <td width="38%"> {{tempPeople.oktPeriodId}} </td>
                      </tr>
                      <tr>
                        <td width="12%" class="grey">享受标准</td>
                        <td width="38%"> {{tempPeople.enjoyTheStandard}} </td>
                        <td width="12%" class="grey">档案状态</td>
                        <td width="38%"> {{tempPeople.state}} </td>
                      </tr>
                      <tr>
                        <td width="12%" class="grey">人员状态</td>
                        <td width="38%"> {{tempPeople.peopleState}} </td>

                      </tr>
                    </table>
                    <div v-if="people.archiveTypeCode=='BLAN_ORP' || people.archiveTypeCode=='POC'">
                      <div  v-if="people.is_father_single=='0' ">
                        <td colspan="2"><h2 class="information_tit">父亲信息</h2></td>
                        <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                          <tr>
                            <td width="12%" class="grey">父亲状态</td>
                            <td width="38%"> {{people.father_status_name}} </td>
                            <td width="12%" class="grey">父亲姓名</td>
                            <td width="38%"> {{people.father_name}} </td>
                          </tr>
                          <tr>
                            <td width="12%" class="grey">父亲手机号</td>
                            <td width="38%"> {{people.father_tel}} </td>
                            <td width="12%" class="grey">父亲户籍地址</td>
                            <td width="38%"> {{people.father_reg_address}} </td>
                          </tr>
                          <tr>
                            <td width="12%" class="grey">父亲居住地址</td>
                            <td width="38%"> {{people.father_address}} </td>
                            <td width="12%" class="grey">父亲证件号</td>
                            <td width="38%"> {{people.father_cred_code}} </td>
                          </tr>
                          <tr>
                            <td width="12%" class="grey">父亲健康状态</td>
                            <td width="38%"> {{people.father_health_name}} </td>
                            <td width="12%" class="grey">是否监护人</td>
                            <td width="38%" v-if="people.is_guardian_father=='0'"> 否</td>
                            <td width="38%" v-if="people.is_guardian_father=='1'"> 是</td>
                          </tr>
                        </table>
                      </div>
                      <div  v-if="people.is_mother_single=='0' ">
                        <td colspan="2"><h2 class="information_tit">母亲信息</h2></td>
                        <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                          <tr>
                            <td width="12%" class="grey">母亲状态</td>
                            <td width="38%"> {{people.mother_status_name}} </td>
                            <td width="12%" class="grey">母亲姓名</td>
                            <td width="38%"> {{people.mother_name}} </td>
                          </tr>
                          <tr>
                            <td width="12%" class="grey">母亲手机号</td>
                            <td width="38%"> {{people.mother_tel}} </td>
                            <td width="12%" class="grey">母亲户籍地址</td>
                            <td width="38%"> {{people.mother_reg_address}} </td>
                          </tr>
                          <tr>
                            <td width="12%" class="grey">母亲居住地址</td>
                            <td width="38%"> {{people.mother_address}} </td>
                            <td width="12%" class="grey">母亲证件号</td>
                            <td width="38%"> {{people.mother_cred_code}} </td>
                          </tr>
                          <tr>
                            <td width="12%" class="grey">母亲健康状态</td>
                            <td width="38%"> {{people.mother_health_name}} </td>
                            <td width="12%" class="grey">是否监护人</td>
                            <td width="38%" v-if="people.is_guardian_mother=='0'"> 否</td>
                            <td width="38%" v-if="people.is_guardian_mother=='1'"> 是</td>
                          </tr>
                        </table>
                      </div>

                    </div>
                    <div v-if="people.centralized=='0'">
                      <td colspan="2"><h2 class="information_tit">集中供养信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="12%" class="grey">入驻福利机构</td>
                          <td width="38%"> {{people.centralized_type_name}} </td>
                          <td width="12%" class="grey">入驻日期</td>
                          <td width="38%"> {{people.centralized_time}} </td>
                        </tr>
                        <tr>
                          <td width="12%" class="grey">福利证号</td>
                          <td width="38%"> {{people.centralized_code}} </td>
                        </tr>
                      </table>
                    </div>
                    <div v-if="people.health=='残疾'">
                      <td colspan="2"><h2 class="information_tit">残疾证信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="12%" class="grey">颁发日期</td>
                          <td width="38%"> {{people.dis_apply_time}} </td>
                          <td width="12%" class="grey">失效日期</td>
                          <td width="38%"> {{people.dis_invalid_time}} </td>
                        </tr>
                        <tr>
                          <td width="12%" class="grey">残疾证号</td>
                          <td width="38%"> {{people.disNum}} </td>
                          <td width="12%" class="grey">残疾类型</td>
                          <td width="38%"> {{disableDetail}} </td>
                        </tr>
                      </table>
                    </div>
                    <div v-else-if="people.health=='健康'"></div>
                    <div v-else>
                      <td colspan="2"><h2 class="information_tit">健康状态描述</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="12%" class="grey">健康状态描述</td>
                          <td  colspan="3"> {{people.healthInfo}} </td>
                        </tr>
                      </table>
                    </div>
                    <div>
                      <td colspan="2"><h2 class="information_tit">银行账户信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="12%" class="grey">卡类型</td>
                          <td width="38%"> {{people.sbkTypeName}} </td>
                          <td width="12%" class="grey">开户银行</td>
                          <td width="38%"> {{people.bankName}} </td>
                        </tr>
                        <tr>
                          <td width="12%" class="grey">银行卡类型</td>
                          <td width="38%"> {{people.bankCardTypeName}} </td>
                          <td width="12%" class="grey">开户证件类型</td>
                          <td width="38%"> {{people.openDocumentTypeName}} </td>
                        </tr>
                        <tr>
                          <td width="12%" class="grey">银行账号</td>
                          <td width="38%"> {{people.bankAccountCode}} </td>
                          <td width="12%" class="grey">开户户名</td>
                          <td width="38%"> {{people.bankAccountName}} </td>
                        </tr>
                        <tr>
                          <td width="12%" class="grey">开户身份证号</td>
                          <td width="38%"> {{people.bankPersonUid}} </td>
                          <td width="12%" class="grey">与申请人的关系</td>
                          <td width="38%"> {{people.bankRelationName}} </td>
                        </tr>

                      </table>
                    </div>
                    <div class="publicity"  v-if="relationListById.length>0">
                      <td colspan="2"><h2 class="information_tit">社会关系信息</h2></td>
                      <table  width="100%" border="0" cellspacing="1" cellpadding="0" >
                        <tr class="first">
                          <td  width="30%">姓名</td>
                          <td width="30%">身份证号</td>
                          <td width="30%">关系</td>
                        </tr>
                        <tr  v-for="(item,index) in relationListById" :key="index">
                          <td align="center" style="width: 200px" nowrap="true">&nbsp;{{item.archiveTypeName}}</td>
                          <td align="center" >&nbsp; {{item.name}}</td>
                          <td align="center" >&nbsp; {{item.person_uid}}</td>
                          <td align="center" >&nbsp; {{item.userRelation}}</td>
                        </tr>
                      </table>
                    </div>
                    <div >
                      <td colspan="2"><h2 class="information_tit">联系人信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="12%" class="grey">紧急联系人</td>
                          <td  colspan="3"> {{people.emergencyName}} </td>
                          <td width="12%" class="grey">紧急联系人电话</td>
                          <td  colspan="3"> {{people.emergencyMobile}} </td>
                        </tr>
                        <tr>
                          <td width="12%" class="grey">与申请人关系</td>
                          <td  colspan="3"> {{people.emergencyRelationName}} </td>
                          <td width="12%" class="grey">备注</td>
                          <td  colspan="3"> {{people.remarks}} </td>
                        </tr>
                      </table>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="附件信息" name="third">
                    <td colspan="2"><h2 class="information_tit">附件信息</h2></td>
                    <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                      <tr><td>
                        <div   v-for="(photo,index) in UploadTypeList"  :key="index+'fjfj'">
                          <div style="width: 100%">
                            <div style="line-height: 27px;margin-bottom: 5px ;font-size: 14px;padding-left: 5px;    font-weight: 600;
      background-color: #f2f3f5;">» {{photo.oneTypeName}}</div>
                            <div  v-for="(two,indexs) in photo.childData"     :key="indexs+'sdsd'" style="display:flex;align-content: left;margin-top: 10px;margin-bottom: 10px;">
                              <div style="width:150px;padding-left: 20px;">
                                {{two.twoTypeName}}</div>
                              <div style="width:100%;text-align: right;" >
                                <img   :src="getImg(two.twoAttachId)" style="width: 180px;height: 150px;" v-if="two.twoAttachId!='' &&two.twoAttachId!='-1'"/>
                                <div style="width: 180px;height: 150px;line-height: 150px;background-color: #e8e8e8;text-align: center;float: right;" v-if="two.twoAttachId=='' ||two.twoAttachId=='-1'">--未上传--</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td></tr>

                    </table>
                  </el-tab-pane>
                  <el-tab-pane label="审批信息" name="fours">
                    <td colspan="2"><h2 class="information_tit">审批信息</h2></td>
                    <el-steps  style="padding-bottom: 50px;" direction="vertical" :active="-1" space="60px">
                      <el-step  v-for="(logs, indexs) in people.billLogList" :key="logs.logId" :title="'【'+logs.optUserName+'】'+logs.optPartyName">
                        <template slot="description">
                          <div style="padding-left: 20px;">
                            {{logs.optTime}}<br/>
                            处理意见：{{logs.suggestion}}
                          </div>
                        </template>
                      </el-step>
                    </el-steps>
                   </el-tab-pane>
                </el-tabs>
              </template>
            </el-dialog>

            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "EnjoyTreatment",
    components: {
      headers, fixedDiv, footers
    },
    created() {
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;

      }
      this.browseLog();
    },
    mounted() {
      var ttt=this;
      this.$https.post("api/pu/peopleUserInfo.do",{},response=> {
        if (response.status === 200 && response.data.code === 200) {
          if (response.data.data.isCertification == '1') {
            ttt.person_uid = response.data.data.userIdcard;
            ttt.flag=1;
            ttt.getPersonInformation();
          }
        }
      })
      this.selectRelation()
    },
    data() {
      return {
        person_uid: '',
        relationList: [],
        relationListById: [],
        value: '',
        activeName3: 'first',
        message: '请输入身份证号查询',
        data: {},
        personInformation:{},
        disableDetail:'',
        people:{},
        tempPeople:{},
        birthday:'',
        health_type:'',
        can_archive_type:[],
        UploadTypeList:[],
        enjoyList:[],
        flag:0,
        loginShow:false,
        detailShow:false,
        gotoIndex:false,
      }
    },
    methods: {
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      browseLog(){
        const options={
          oneCode:'bmcx',
          twoCode:'zxdycx',
        }
        this.$https.post("api/browse/saveBrowseLog.do",options,response=>{
        })
      },
      selectRelation(){
        const options={
        }
        //查找用户关系
        this.$https.post("api/choice/selectRelationAll.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            this.relationList=response.data.data;
          } else {
            // t.departOption =[];
          }
        })
      },
      selectRelationById(uid){
        const options={uid:uid};
        let t=this;
        this.$https.post("/api/ywt/apply/selectRelation.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            this.relationListById=response.data.data;
          }
        })
      },
      detailSelect(code,id,item){
        this.detailShow=true;
        //上半部分信息展示
        this.tempPeople=item;
        const options={
          billId:id,
          archiveTypeCode:code,
        };
        let t=this;
        this.$https.post("/api/archiveBill/getArchiveBillInfo.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            this.selectRelationById(this.personInformation.person_uid)
            t.people=response.data.data;
            t.UploadTypeList= t.people.attachJson
            t.disableDetail='';
            if (t.people.disList.length>0){
              for (let i = 0; i < t.people.disList.length; i++) {
                if (0==t.people.disList.length-1){
                  t.disableDetail+= t.people.disList[i].dt_name+'('+t.people.disList[i].dl_name+')';
                }else {
                  t.disableDetail+= ','+t.people.disList[i].dt_name+'('+t.people.disList[i].dl_name+')';
                }
              }
            }
            if (t.people.centralized_time.length>7){
              //切割入住日期
              let s1 = this.people.centralized_time.substring(0,4);
              let s2 = this.people.centralized_time.substring(4,6);
              let s3 = this.people.centralized_time.substring(6,8);
              this.people.centralized_time=s1+"-"+s2+"-"+s3;
            }
          }else {
            Toast.fail("获取详情信息失败");
          }})
      },
      getPersonInformation() {
        if (!this.$util.isEmpty(this.value)){
          this.person_uid=this.value
        }

        if (this.$util.isEmpty(this.person_uid)) return;
        this.$https.post("/api/ywt/apply/getPersonEnjoy.do", {person_uid: this.person_uid}, response => {
          if (response.status === 200 && response.data.code === 200) {
            if ( response.data.data!==null && !this.$util.isEmpty(response.data.data.person_name)) {
              this.health_type="";
              this.birthday='';
              this.personInformation = response.data.data;
              this.getPersonEnjoyList();
           /*   //切割生日字符串
              var s1 = this.personInformation.person_birthday.substring(0,4);
              var s2 = this.personInformation.person_birthday.substring(4,6);
              var s3 = this.personInformation.person_birthday.substring(6,8);
              this.birthday=s1+"-"+s2+"-"+s3;
              if (this.personInformation.dis_type!=null && this.personInformation.dis_level!=null){
                //切割残疾类型
                var split1 = this.personInformation.dis_type.split(",");
                var split2 = this.personInformation.dis_level.split(",");
                for (let i = 0; i < split1.length; i++) {
                  if (this.health_type==''){
                    this.health_type=split1[i]+"("+split2[i]+")"
                  }else {
                    this.health_type=","+split1[i]+"("+split2[i]+")"
                  }
                }
              }*/

            }else {
              if(this.flag==0){
                this.$message.error('暂未查到此身份证待遇信息，请检查输入是否有误！');
                this.message='暂未查到此身份证待遇信息，请检查输入是否有误！'
                this.personInformation= {};
              }else{
                this.flag=0;
              }

            }
          }
        });
      },
      getPersonEnjoyList(){
        const options={
          person_uid:this.personInformation.person_uid,
          source:'work',
        }
        this.$https.post("/api/ywt/apply/getPersonEnjoyList.do",options,response=>{
          if (response.status === 200 && response.data.code === 200) {
            this.enjoyList=response.data.data;
          }
        });
      },
      getImg(imgId){
        let dd=this.$util.req.getshowImg(imgId);
        return dd;
      },
      searchData() {
        if (this.$util.isEmpty(this.person_uid)) return;
        this.$https.post("/api/zj/getAllEnjoyTreat.do", {person_uid: this.person_uid}, response => {
          if (response.status === 200 && response.data.code === 200) {
            if (!this.$util.isEmpty(response.data.data)) {
              this.data = response.data.data;
            }
          }
        });
      },

    },
  }
</script>

<style scoped>
  .ctt {
    background: #fff;
    padding: 16px 2%;
  }

  .tit {
    background: #f7f7f7;
    font-weight: bold;
    text-align: center;
  }
  .publicity table td {
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/usualservice/EnjoyTreatment.vue